// extracted by mini-css-extract-plugin
export default {"container":"container--eE0jH","placeholder":"placeholder--IsgYJ","form-input":"form-input--hm4x8","formInput":"form-input--hm4x8"};